/**
 * Внешний вид интерфейса: тема и фокус-режим (ТЗ UX-01, UX-03).
 *
 * Тема — не украшение, а условие работы: тренажёром пользуются подолгу и
 * часто вечером. Выбор пользователя главнее системной настройки, но не
 * заменяет её: «как в системе» остаётся значением по умолчанию, потому что
 * человек, настроивший тёмную тему в ОС, ждёт её и здесь.
 */

/** Что пользователь выбрал: конкретную тему или «как в системе». */
export const THEME_PREFERENCES = ['system', 'light', 'dark'] as const;
export type ThemePreference = (typeof THEME_PREFERENCES)[number];

/** Тема, которая в итоге применяется: «как в системе» разрешается в одну из двух. */
export const RESOLVED_THEMES = ['light', 'dark'] as const;
export type ResolvedTheme = (typeof RESOLVED_THEMES)[number];

/**
 * Атрибут корневого элемента, которым задаётся тема.
 *
 * Атрибут, а не класс: значений три, и класс пришлось бы снимать перед
 * установкой нового. Отсутствие атрибута означает «как в системе» — тогда
 * работает `prefers-color-scheme`, и лишнего кода не нужно вовсе.
 */
export const THEME_ATTRIBUTE = 'data-theme';

/** Тема по умолчанию: следовать настройке операционной системы. */
export const DEFAULT_THEME: ThemePreference = 'system';

/**
 * Разрешает выбор пользователя в конкретную тему.
 *
 * @param preference выбор пользователя;
 * @param systemPrefersDark включена ли тёмная тема в системе.
 */
export function resolveTheme(
  preference: ThemePreference,
  systemPrefersDark: boolean,
): ResolvedTheme {
  if (preference === 'system') return systemPrefersDark ? 'dark' : 'light';
  return preference;
}

/** Проверяет, что строка — известный выбор темы. */
export function isThemePreference(value: string): value is ThemePreference {
  return (THEME_PREFERENCES as readonly string[]).includes(value);
}
